import * as React from "react";
export { Main };
/**
 * Контейнер для основного содержимого страницы.
 * @param {Object} props - Атрибуты элемента.
 * @param {JSX.Element} props.children - Содержимое.
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link StudioFrame.jsx}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Main({ children }) {
  return <main>{children}</main>;
}
